<template>
  <v-list shaped :class="'pointer ' + bg" max-width="500">
    <v-list-item-group v-model="section_model" color="primary">
      <v-list-item v-for="(item, i) in [1]" :key="i">
        <v-list-item-icon>
          <v-icon v-text="icon" :nothing="item"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-h6 text-left" v-text="label"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    }
  },
  data: () => ({
      section_model: 0
  })
};
</script>